export default "__VITE_ASSET__591aaa33__"